import { 
    PUBLISH_FAIL, PUBLISH_REQUEST, PUBLISH_SUCCESS
  } from "../constant";
  
  const initialState = {
    publishData: 2
  }
  
  const publishReducer = (state = initialState, action) => {
    switch (action.type) {
      case PUBLISH_REQUEST:
        return state
  
      case PUBLISH_FAIL:
        return  state
  
      case PUBLISH_SUCCESS:
        console.log('action?.payload', action?.payload?.[0].su_is_active);
        return {
          ...state,
          publishData :action?.payload?.[0].su_is_active
        }

      default:
        return state;
    }
  }
  
  export default publishReducer